import React, { createContext, useState, useContext, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = () => {
    const token = localStorage.getItem("token");
    // console.log('AuthContext: Checking token:', token ? 'Found' : 'Not found');
    
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        // console.log('AuthContext: Decoded token:', decodedToken);
        setAuth(decodedToken);
        
        // Store user in localStorage for easier access
        if (decodedToken) {
          localStorage.setItem("byteUser", JSON.stringify(decodedToken));
        }
      } catch (error) {
        console.error("AuthContext: Invalid token:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("byteUser");
        setAuth(null);
      }
    } else {
      // console.log('AuthContext: No token found, setting auth to null');
      setAuth(null);
    }
  };

  useEffect(() => {
    // console.log('AuthContext: Checking auth on mount');
    checkAuth();
    setLoading(false);

    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
